/* global pep_global_config */

import { FocusTrap } from '../../module/focus_trap';

export default function initLanguageMenu() {
    const language_popup = document.getElementById('language-popup');

    if (language_popup) {
        const trap = new FocusTrap(language_popup);

        // popup positioning and focus trapping
        document.querySelectorAll('[aria-controls="language-popup"]').forEach(function(button) {
            button.addEventListener('click', function() {
                language_popup.style.right = document.documentElement.clientWidth - button.getBoundingClientRect().right + button.getBoundingClientRect().width / 2 + 'px';
                language_popup.style.top = button.getBoundingClientRect().bottom + 'px';

            });
        });

        language_popup.addEventListener('menu-opened', () => {
            trap.setTrap();
        });
        language_popup.addEventListener('menu-closed', () => {
            trap.releaseTrap();
        });
    }


    // toggle current language when using clonable
    const config = pep_global_config.clonable_languages ?? '';
    if (config.length < 1) {
        return;
    }
    const clonables = config.split(',');
    const url = new URL(location);
    const links = document.querySelectorAll('#service-menu .languages a');

    if (links.length < 2) {
        return;
    }

    let current = links[0].innerText.toLowerCase().trim();
    clonables.forEach((clonable) => {
        if (url.pathname.startsWith('/' + clonable + '/')) {
            // current lang is actually this clonable lang,
            // so switch the language switcher to this language
            current = clonable;
        }
    });

    links.forEach((link) => {
        if (link.innerText.toLowerCase().trim() === current) {
            link.classList.add('hidden');
        } else {
            link.classList.remove('hidden');
            // clonable might have change this link, so take it back
            link.setAttribute('href', link.getAttribute('href').replace('/' + current + '/', '/'));
        }
    });
}
